export const accessRules = {
  hasAccessToCreativeStudio: () => true,
  // Clients keep the old Looker dashboard; the new native dashboard is shown only
  // while a core-team member impersonates a client (see DashboardView).
  hasAccessToDashboard: auth => auth.isImpersonated || (auth.userHasCompany && auth.authUser.subrole === 'admin'),
  hasAccessToAdPerformanceOverview: () => true,
  hasAccessToPerformanceReport: (auth, to) => auth.performanceReportAvailability?.[to?.params?.platform] === true,
  hasAccessToTeam: auth => auth.isCompanyAdmin,
  hasAccessToMyRequests: auth => auth.userHasCompany,
  hasAccessToRequestsPage: auth => auth.hasAccessToRequestsPage,
  hasAccessToAdAccountRequests: auth => auth.userHasCompany,
  hasAccessToAccountRenameRequests: auth => auth.userHasCompany,
  hasAccessToTopUpRequestsPage: auth => auth.userHasCompany,
  hasAccessToWhiteListRequestsPage: auth => auth.userHasCompany,
  // Policy page is gated behind developer impersonation until rollout (see CU-869em758a).
  hasAccessToPolicyPage: auth => auth.isImpersonatedByDeveloper,
  hasAccessToSharePermissionRequestsPage: auth => auth.userHasCompany,
  hasAccessToFBPageRequestsPage: auth => auth.userHasCompany,
  hasAccessToFBPageRequestFormPage: auth => auth.canSeeFBPageRequestForm,
  hasAccessToCreativeModerationList: auth => auth.canWorkWithCreatives,
  hasAccessToCreativeModerationProfile: auth => accessRules.hasAccessToCreativeModerationList(auth),
  hasAccessToPaymentsDailyBalance: auth => auth.userHasCompany,
  hasAccessToFinancePage: auth => auth.canUseInvoices,
  // Retainers are hidden behind the can_use_retainers policy flag until rollout.
  hasAccessToRetainers: auth => auth.canUseRetainers,
  hasAccessToAssetsPage: auth => auth.hasAccessToAssetsPage,
  canAssignAdAccountUser: auth => auth.isCompanyAdmin,
  canCreateCreativeModerationRequest: auth => auth.userHasCompany,
}
